/**
 * These are the defined types of user input that can hydrate a configured
 * dataShape.
 *
 * These field types map to input elements and specific validation and processing functions.
 */
export var FieldType;
(function (FieldType) {
    FieldType["STRING"] = "string";
    FieldType["NUMBER"] = "number";
    FieldType["INT"] = "int";
    FieldType["IMAGE"] = "image";
    FieldType["MARKDOWN"] = "markdown";
    FieldType["AUDIO"] = "audio";
    FieldType["MIDI"] = "midi";
    FieldType["MEDIA_UPLOADS"] = "uploads";
    FieldType["CHESS_PUZZLE"] = "chess_puzzle";
})(FieldType || (FieldType = {}));
//# sourceMappingURL=FieldType.js.map